import { fetchApi } from "../fetchApi";

export const onChangeProductSocialMediaPost = async ({
  context,
  company_id,
  defaultLines,
}) => {
  const raw = JSON.stringify({
    jsonrpc: "2.0",
    method: "call",
    params: {
      args: [
        [],
        {},
        [],
        {
          custom_merchant_post_message: "",
          lines: "",
          "lines.selected": "",
          "lines.ayrshare_id": "",
          "lines.display_name": "",
        },
      ],
      model: "active.social.media",
      method: "onchange",
      kwargs: {
        context: {
          lang: context.lang,
          tz: context.tz,
          uid: context.uid,
          allowed_company_ids: [company_id],
          params: {
            cids: company_id,
            model: "active.social.media",
            view_type: "list",
          },
          active_model: "active.social.media",
          //   active_id: 26177,
          //   active_ids: [26177],
          //   parent_obj_id: 26177,
          default_lines: defaultLines,
        },
      },
    },
  });

  const requestOptions = {
    method: "POST",
    body: raw,
    redirect: "follow",
  };

  let response = await fetchApi({
    requestOptions,
    endpoint: "/web/dataset/call_kw/active.social.media/onchange",
    // endpoint: "web/dataset/call_kw/active.social.media/onchange",
  });
  response = JSON.parse(response);
  return response;
};
